"use client"

import styled, { css } from "styled-components"

import { Label as TSRLabel } from "@/design/tsr-ui/components"

export function getLabelStyles({ theme, error }) {
  const { spaces } = theme
  const { danger, dimmed } = theme.colors
  const { size, lineHeight } = theme.fonts
  return css`
    margin-left: ${spaces.small};
    margin-bottom: ${spaces.xxs};
    font-size: ${size.smallParagraph};
    line-height: ${lineHeight.oneAndHalf};
    color: ${error ? danger.bg : dimmed.bg};
  `
}

export const Label = styled(TSRLabel)`
  ${({ theme }) => {
    return css`
      ${getLabelStyles}
    `
  }}
`
